import { Box } from "@chakra-ui/react";
import React, { useState } from "react";
import { Document, Page } from "react-pdf";

const PDFViewer: React.FC<{ pdfUrl: string }> = ({ pdfUrl }) => {
  const [numPages, setNumPages] = useState<number | null>(null);

  function onDocumentLoadSuccess({ numPages }: { numPages: number }) {
    setNumPages(numPages);
  }

  console.log('the pdf file viewer has been called')
  return (
    <>
      {/* <Box
    position="fixed"
    top="50px"
    left="0"
    right="0"
    background="white"
    zIndex="1">
    <Text >
        Page {pageNumber} of {numPages}
      </Text>
      </Box> */}
      <Box
        className="pdf-div"
        // overflowY="auto"
        // border="2px"
        // overflowX="auto"
        // overflowY="auto"
        // className="customScrollBar"
        // height="85vh"
        // width="100%"
        // p={0}
        // m={0}
      >
        <Document file={pdfUrl} onLoadSuccess={onDocumentLoadSuccess}>
          {Array.apply(null, Array(numPages))
            .map((x: any, i: any) => i + 1)
            .map((page: any) => {
              return (
                <Page
                  pageNumber={page}
                  renderTextLayer={false}
                  renderAnnotationLayer={false}
                  width={window.innerWidth - 2 * 14}
                />
              );
            })}
        </Document>
      </Box>
    </>
  );
};

export default PDFViewer;
